<template>
  <div>
    <v-btn icon @click="openDialog()">
      <v-icon :color="ui.btnColorError" v-if="this.result.basic.atn === true">
        notifications_active
      </v-icon>
      <v-icon :color="ui.btnColorWarning" v-else-if="this.result.basic.read === false">
        mark_email_unread
      </v-icon>
      <v-icon :color="ui.btnColor" v-else>
        email
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogSmall">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <span :class="ui.textTitle">
              <v-icon left :color="ui.btnColor">
                {{defineDocumentFromTag(result.char.tag).icon}}
              </v-icon>
              {{defineDocumentFromTag(result.char.tag).title}}
            </span>
            <v-spacer/>
            <span :class="ui.textTitle">
              {{displayDocumentIDGTypeA(result.char.tag, result.char.idg)}}
            </span>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text>
          <v-layout row>
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon
                  v-if="this.result.char.did !== this.getUser.basic.did">
                  title
                </v-icon>
                <v-icon v-else>
                person
              </v-icon>
                </v-avatar>
                <span :class="ui.textSubheadingBold">
                  {{result.char.title}}
                </span>
              </v-chip>
            </span>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" v-if="result.basic.act === false">
              <v-icon :color="ui.btnColor">
                lock
              </v-icon>
            </v-chip>
          </v-layout>
          <v-layout row v-if="false">
            <span :class="ui.textSubheading"
            v-if="this.result.char.did !== this.getUser.basic.did"
            >
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>sell</v-icon>
                </v-avatar>
                {{result.char.id}}
              </v-chip>
            </span>
            <v-spacer/>
            <span :class="ui.textSubheading">
              <v-icon :color="ui.btnColorError" v-if="this.result.basic.atn === true">
                notifications_active
              </v-icon>
              <v-icon :color="ui.btnColorWarning" v-else-if="this.result.basic.read === false">
                mark_email_unread
              </v-icon>
              <v-icon :color="ui.btnColor" v-else>
                email
              </v-icon>
            </span>
          </v-layout>
          <v-layout row v-if="result.basic.tag === 'B3'">
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>account_balance</v-icon>
                </v-avatar>
                <!-- {{result.relps.source[0].cname}} -->
              </v-chip>
            </span>
            <v-spacer/>
          </v-layout>

          <v-layout class="text-xs-left ml-2 mr-2 mt-4">
            <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
              <v-avatar>
              <v-icon> short_text </v-icon>
              </v-avatar>
              Activity Log Description
            </v-chip>
          </v-layout>
          <v-layout row wrap class="mt-0 ml-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon :color="ui.btnColorGrey"> edit </v-icon>
              </v-avatar>
              <span :class="ui.textDescription">
                {{result.stats.uname}}
              </span>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
              <v-avatar>
                <v-icon :color="ui.btnColorGrey">schedule</v-icon>
              </v-avatar>
              <span :class="ui.textDescription">
                {{dateTimeAgo(result.stats.dcrt)}}
              </span>
            </v-chip>
          </v-layout>
          <v-layout class="text-xs-left ml-4 mr-2 mt-2">
            <div :class="ui.textDescription">
              {{this.generateDocumentLogShortText(result.char.tag, result.char.tverb)}}
          </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon> exit_to_app </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :color="ui.btnColorError" flat
            @click="changeDocoumentAttentionStatus(!result.basic.atn)"
            v-if="this.result.basic.read === false">
            <v-icon v-if="this.result.basic.atn === true" left>
              notifications_off
            </v-icon>
            <v-icon v-else left>
              notification_important
            </v-icon>
            <div v-if="this.result.basic.atn === true">
              Stop Watching
            </div>
            <div v-else>
              Watch
            </div>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo2" v-if="btnSpinDocumentRead === true"/>
          <v-btn :color="ui.btnColor" flat
            @click="changeDocoumentReadStatus(!result.basic.read)"
            v-if="
            btnSpinDocumentRead === false &&
            result.basic.atn === false
            ">
            <v-icon v-if="this.result.basic.read === true" left>
              mark_email_unread
            </v-icon>
            <v-icon v-else left>
              mark_email_read
            </v-icon>
            <div v-if="this.result.basic.read === true">
              unread
            </div>
            <div v-else>
              read
            </div>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinDocumentRead === true"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import textFunctions from "@/data/functions/mixins/textFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import updateFirebase from "@/data/cloud/firebase/mixins/updateFirebase.js";
import countFunctions from "@/data/functions/mixins/countFunctions.js";

export default {
  mixins: [
    apptheme,
    dateFunctions,
    numberFunctions,
    storeFunctions,
    routerFunctions,
    describeDocument,
    displayFunctions,
    textFunctions,
    dataSources,
    updateFirebase,
    countFunctions
  ],
  components: {
    BtnSpin
  },
  data() {
    return {
      dialog: false,
      valid: false,
      btnSpinDocumentRead: false,
      btnSpinDocumentAttention: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      btnInfo2: {
        color: "red",
        icon: "person",
        name: "add user"
      }
    };
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getDataSource",
      "getPageInfo",
      "getSearchResults",
      "getDocumentLogTag"
    ]),
    result() {
      return this.data.item;
    },
    enableNotiStatus() {
      let logic = null;
      let tag = this.result.char.tag;
      if (tag === "U1") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
      this.btnSpinDocumentRead = false;
      this.btnSpinDocumentAttention = false;
      // DEFINE path for the db.
      // let collectionDID = this.result.char.did;
      // this.$store.dispatch("changeDocumentLogTag", collectionDID);
    },
    closeDialog() {
      this.dialog = false;
      this.btnSpinDocumentRead = false;
    },
    changeDocoumentReadStatus(logic) {
      this.btnSpinDocumentRead = true;
      let did = this.result.basic.did;
      let tagd = this.getDocumentLogTag;
      let db = this.defineDataSourceFromTagForRelationship("D3", tagd);
      let temp = this.result;
      temp.basic.read = logic;
      this.updateFirebaseDocumentDirect(db, did, this.result);
      this.updateNotificationsCounters();
    },
    changeDocoumentAttentionStatus(logic) {
      this.btnSpinDocumentAttention = true;
      let did = this.result.basic.did;
      let tagd = this.getDocumentLogTag;
      let db = this.defineDataSourceFromTagForRelationship("D3", tagd);
      let temp = this.result;
      temp.basic.atn = logic;
      this.updateFirebaseDocumentDirect(db, did, this.result);
      this.updateNotificationsCounters();
    },
    updateNotificationsCounters() {
      let tag = this.getPageInfo.tag;
      let list = this.getSearchResults;
      let readCtr = 0;
      let atnCtr = 0;
      // UPDATE USER COUNTERS
      if (tag === "U1") {
        readCtr = this.countItemOnCondition(false, "basic.read", list);
        atnCtr = this.countItemOnCondition(true, "basic.atn", list);
        this.$store.dispatch("changeDocumentLogUserUnreadCounter", readCtr);
        this.$store.dispatch("changeDocumentLogUserAttentionCounter", atnCtr);
      }
      // UPDATE COMPANY COUNTERS
      if (tag === "C1") {
        readCtr = this.countItemOnCondition(false, "basic.read", list);
        atnCtr = this.countItemOnCondition(true, "basic.atn", list);
        // eslint-disable-next-line
        this.$store.dispatch("changeDocumentLogCompanyUnreadCounter", readCtr);
        // eslint-disable-next-line
        this.$store.dispatch("changeDocumentLogCompanyAttentionCounter", atnCtr);
      }
      // UPDATE FACILITY COUNTERS
      if (tag === "F1") {
        readCtr = this.countItemOnCondition(false, "basic.read", list);
        atnCtr = this.countItemOnCondition(true, "basic.atn", list);
        // eslint-disable-next-line
        this.$store.dispatch("changeDocumentLogCompanyUnreadCounter", readCtr);
        // eslint-disable-next-line
        this.$store.dispatch("changeDocumentLogCompanyAttentionCounter", atnCtr);
      }
    }
  }
};
</script>
